<svg width="60" height="16" viewBox="0 0 60 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 5">
        <path id="Path 8" d="M1.5 1.75C1.5 1.75 15.8425 14.8313 30 14.8934C44.1575 14.9555 58.5 2 58.5 2"
              stroke="#77E0C8" strokeWidth="2" stroke-linecap="round" stroke-dasharray="2 4"/>
        <path id="Path 3" d="M53.5 2H58.5V7" stroke="#77E0C8" strokeWidth="1.5"/>
    </g>
</svg>
